export default __webpack_public_path__ + "static/media/icon_cb_19.2afaaa27.png";